/* MJ collection cards (Oct 2026): tell Shopify's customer events when a grid card is seen and clicked.
   Events: mj_card_view and mj_card_click, with { card, name, slot, collection }.
   A custom pixel (Settings > Customer events) can forward them to GA4 as view_promotion / select_promotion. */
(function () {
  'use strict';
  var seen = {};

  function publish(name, card) {
    var grid = document.getElementById('product-grid');
    var data = {
      card: card.getAttribute('data-mj-card') || '',
      name: card.getAttribute('data-mj-card-name') || '',
      slot: Number(card.getAttribute('data-mj-slot') || 0),
      collection: (grid && grid.getAttribute('data-collection')) || ''
    };
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        window.Shopify.analytics.publish(name, data);
      }
    } catch (error) { /* analytics must never break the page */ }
  }

  function watch() {
    var cards = document.querySelectorAll('#product-grid .mj-ccard');
    if (!cards.length) return;
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
          var key = entry.target.getAttribute('data-mj-card') + ':' + entry.target.getAttribute('data-mj-slot');
          if (seen[key]) return;
          seen[key] = true;
          publish('mj_card_view', entry.target);
          io.unobserve(entry.target);
        });
      }, { threshold: [0.5] });
      cards.forEach(function (card) { io.observe(card); });
    }
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('#product-grid .mj-ccard [data-mj-card-link]');
    if (link) publish('mj_card_click', link.closest('.mj-ccard'));
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch);
  else watch();

  // The grid is re-rendered when filters change
  var container = document.getElementById('ProductGridContainer');
  if (container && 'MutationObserver' in window) {
    new MutationObserver(function () { window.setTimeout(watch, 150); }).observe(container, { childList: true });
  }
})();
